import axiosInstance from '../axiosInstance';

export const initTaxiOrder = async (ordId, manId) => {
    const { data } = await axiosInstance.post(`/administration/taxi-service/orders/${ordId}/manifests/${manId}/init`);
    return data.data;
};

export const notifyInitialWhatsApp = async (ordId) => {
    const { data } = await axiosInstance.post(`/administration/taxi-service/orders/${ordId}/notify-processing`);
    return data.data;
};

export const triggerTaxiRouting = async (ordId) => {
    const { data } = await axiosInstance.post(`/administration/taxi-service/orders/${ordId}/generate-routes`);
    return data;
};

export const getTaxiRoutingJob = async (jobId) => {
    const { data } = await axiosInstance.get(`/administration/taxi-service/routing-jobs/${jobId}`);
    return data.job;
};

// ============================================================
// ENDPOINTS PARA EQUIPOS
// ============================================================

/**
 * Obtener todos los equipos (activos e inactivos)
 */
export const fetchTeams = async () => {
    const response = await axiosInstance.get('/administration/taxi-service/taxi-teams/list');
    return response.data;
};

/**
 * Crear un nuevo equipo (empleado + vehículo ya existen)
 * @param {Object} data - { empId, vehId, serProIds, nombre }
 */
export const createTeam = async (data) => {
    const response = await axiosInstance.post('/administration/taxi-service/taxi-teams', data);
    return response.data;
};

/**
 * Actualizar los servicios-proyecto de un equipo (reemplazo completo)
 * @param {number} equConVehId - ID del equipo
 * @param {Object} data - { serProIds: [...] }
 */
export const updateTeamServices = async (equConVehId, data) => {
    const response = await axiosInstance.put(`/administration/taxi-service/taxi-teams/${equConVehId}/services`, data);
    return response.data;
};

/**
 * Eliminar (desactivar) un equipo (borrado lógico)
 */
export const deleteTeam = async (equConVehId) => {
    const response = await axiosInstance.delete(`/administration/taxi-service/taxi-teams/${equConVehId}`);
    return response.data;
};

/**
 * Obtener detalle de un equipo por ID
 */
export const getTeamById = async (equConVehId) => {
    const response = await axiosInstance.get(`/administration/taxi-service/taxi-teams/${equConVehId}`);
    return response.data;
};

